import { Link } from '@heroui/react';
import { useState } from 'react';

interface IStoppageEventsMapLegendProps {
	onSelectionChange: (selection: string) => void;
}

const StoppageEventsMapLegend: React.FC<IStoppageEventsMapLegendProps> = ({ ...props }) => {
	const [selected, setSelected] = useState('');

	const onSelectionChange = (selection: string) => {
		if (selected === selection) {
			setSelected('');
			props.onSelectionChange('');
			return;
		} else {
			setSelected(selection);
			props.onSelectionChange(selection);
		}
	};

	return (
		<div className="flex space-x-1 text-sm whitespace-nowrap">
			<Link
				className={`flex items-center space-x-2 cursor-pointer text-msi-black-color opacity-50 ${selected !== '' && selected !== 'Stopped (at anchor)' ? 'opacity-50' : 'opacity-100'}`}
				onPress={() => onSelectionChange('Stopped (at anchor)')}
			>
				<span className="w-3 h-3 bg-msi-stoppages-anchored rounded-full"></span>
				<span className="">Stopped (at anchor)</span>
			</Link>
			<Link
				className={`flex items-center space-x-2 cursor-pointer text-msi-black-color opacity-50 ${selected !== '' && selected !== 'Stopped (moored)' ? 'opacity-50' : 'opacity-100'}`}
				onPress={() => onSelectionChange('Stopped (moored)')}
			>
				<span className="w-3 h-3 bg-msi-stoppages-moored rounded-full"></span>
				<span>Stopped (moored)</span>
			</Link>
			<Link
				className={`flex items-center space-x-2 cursor-pointer text-msi-black-color opacity-50 ${selected !== '' && selected !== 'Stopped (Unclassified)' ? 'opacity-50' : 'opacity-100'}`}
				onPress={() => onSelectionChange('Stopped (Unclassified)')}
			>
				<span className="w-3 h-3 bg-msi-stoppages-unclassified rounded-full"></span>
				<span>Stopped (Unclassified)</span>
			</Link>
		</div>
	);
};

export default StoppageEventsMapLegend;
